import { TextField } from '@mui/material';
import { useState } from 'react';

const TextOnCaseInput = ({ placeholder, length, currValue, control, style }) => {
    const [isEmojiUsed, setIsEmojiUsed] = useState(false);
    let onValueUpdate = (value) => {
        const emojiPattern =
            /([\u{1F600}-\u{1F64F}]|[\u{1F300}-\u{1F5FF}]|[\u{1F680}-\u{1F6FF}]|[\u{1F700}-\u{1F77F}]|[\u{1F780}-\u{1F7FF}]|[\u{1F800}-\u{1F8FF}]|[\u{1F900}-\u{1F9FF}]|[\u{1FA00}-\u{1FA6F}]|[\u{1FA70}-\u{1FAFF}]|[\u{2600}-\u{26FF}]|[\u{2700}-\u{27BF}]|[\u{FE00}-\u{FE0F}]|[\u{1F1E6}-\u{1F1FF}]|[\u{1F201}-\u{1F251}]|[\u{1F004}-\u{1F0CF}]|[\u{1F018}-\u{1F270}]|[\u{1F32D}-\u{1F335}]|[\u{1F37D}-\u{1F393}]|[\u{1F3C3}-\u{1F3CA}]|[\u{1F3CF}-\u{1F3D3}]|[\u{1F3E0}-\u{1F3E3}]|[\u{1F3E5}-\u{1F3E9}]|[\u{1F3EA}-\u{1F3ED}]|[\u{1F3F0}-\u{1F3F5}]|[\u{1F3F7}-\u{1F3FC}]|[\u{1F400}-\u{1F4FD}]|[\u{1F4FF}-\u{1F53D}]|[\u{1F54B}-\u{1F54E}]|[\u{1F550}-\u{1F567}]|[\u{1F595}-\u{1F596}]|[\u{1F5A4}-\u{1F5A5}]|[\u{1F5A8}-\u{1F5B0}]|[\u{1F5B1}-\u{1F5B2}]|[\u{1F5BC}-\u{1F5BD}]|[\u{1F5BF}-\u{1F5C0}]|[\u{1F5C2}-\u{1F5C4}]|[\u{1F5D1}-\u{1F5D3}]|[\u{1F5E1}-\u{1F5E3}]|[\u{1F5E8}-\u{1F5E9}]|[\u{1F5EF}-\u{1F5F1}]|[\u{1F5F3}-\u{1F5FA}]|[\u{1F5FB}-\u{1F5FE}]|[\u{1F5FF}-\u{1F64F}]|[\u{1F680}-\u{1F6C5}]|[\u{1F6CB}-\u{1F6D2}]|[\u{1F6E0}-\u{1F6E5}]|[\u{1F6E9}-\u{1F6E9}]|[\u{1F6EB}-\u{1F6EC}]|[\u{1F6F0}-\u{1F6F3}]|[\u{1F6F4}-\u{1F6F6}]|[\u{1F6F8}-\u{1F6F8}]|[\u{1F6FB}-\u{1F6FC}]|[\u{1F7E0}-\u{1F7EB}]|[\u{1F90D}-\u{1F93A}]|[\u{1F93C}-\u{1F945}]|[\u{1F947}-\u{1F978}]|[\u{1F97A}-\u{1F9A2}]|[\u{1F9A5}-\u{1F9AA}]|[\u{1F9AE}-\u{1F9C3}]|[\u{1F9C5}-\u{1F9C6}]|[\u{1F9C7}-\u{1F9C7}]|[\u{1F9C9}-\u{1F9CA}]|[\u{1F9CD}-\u{1F9FF}]|[\u{1FA70}-\u{1FA74}]|[\u{1FA78}-\u{1FA7A}]|[\u{1FA80}-\u{1FA82}]|[\u{1FA90}-\u{1FA95}]|[\u{1FAA0}-\u{1FAA6}]|[\u{1FAB0}-\u{1FAB6}]|[\u{1FAC0}-\u{1FAC2}]|[\u{1FAD0}-\u{1FAD6}]|[\u{1F1E6}-\u{1F1FF}])/gu;
        const regex = new RegExp(emojiPattern);
        if (regex.test(value.target.value)) {
            setIsEmojiUsed(true);
        } else {
            setIsEmojiUsed(false);
        }
        control(value.target.value);
    };
    return (
        <>
            <TextField
                style={{ width: '100%', marginTop: '5px', marginBottom: '5px', ...style }}
                type="text"
                onChange={onValueUpdate}
                value={currValue !== undefined ? currValue : ''}
                placeholder={placeholder}
                size="small"
                inputProps={{ maxLength: length }}
                pattern="[a-zA-Z\s&\d]"
            />
            {isEmojiUsed && (
                <p style={{ color: 'red' }}>(Emoji is not supported for case engraving)</p>
            )}
        </>
    );
};

export default TextOnCaseInput;
